import { BRTokenId, IBRErcToken } from 'types';
import { BRERC_TOKENS } from 'constants/tokens';

export const getBRErcToken = (id: BRTokenId) => BRERC_TOKENS[id] as IBRErcToken;

export default getBRErcToken;
